<script>
    import Viewer from '../../../../../utils/tui-editor/Viewer.svelte'
    import {getDateTimeFromIsoStr} from "../../../../../utils";
    export let source
    export let rewardDistributionDate
</script>

<div class="tabs-preview-wrapper">
    {#if rewardDistributionDate}
        <div class="estimated-delivery-date">
            <span>Estimated Delivery: {getDateTimeFromIsoStr(rewardDistributionDate)}</span>
        </div>
    {/if}
    {#if source}
        <Viewer {source} />
    {/if}
</div>